<template>
  <div
    class="mt-10 mb-10"
  >
    <div class="justify-between items-center md:flex hidden">
      <SkeletonLoader
        height="32px"
        width="350px"
      />
      <div class="flex items-center">
        <SkeletonLoader
          height="72px"
          width="200px"
        />
        <SkeletonLoader
          height="48px"
          width="218px"
          class="md:ml-5"
        />
      </div>
    </div>
    <hr class="hidden md:block mt-6 mb-6 bg-EXPONDO-grey-5">
    <div class="md:hidden block">
      <SkeletonLoader
        height="32px"
        width="50%"
      />
      <hr class="md:hidden mt-6 mb-10 bg-EXPONDO-grey-5 mx-5 md:mx-0">
      <SkeletonLoader
        height="60px"
        width="240px"
      />
      <SkeletonLoader
        class="my-5"
        height="48px"
      />
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'RatingsReviewsSkeleton',
});

</script>
